
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marine-algae/[category]",
      function () {
        return require("private-next-pages/marine-algae/[category]/index.js");
      }
    ]);
  